// extracted by mini-css-extract-plugin
export default {"list":"SidebarList_list__gAase","error":"SidebarList_error__Lphfg"};